<template>
  <div class="search-sub-container" style="display: flex">
    <div class="content" v-if="total > 0 || scrollFlag">
      <OneMessage :messageList="messageList" :type="type"/>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
    </div>
    <NoData v-if="total <= 0 && !scrollFlag"></NoData>
  </div>
</template>

<script>
import OneMessage from "../components/OneMessage.vue";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    OneMessage,
    Scroll,
    NoData
  },
  props: ["type"],
  data() {
    return {
      messageList: [],
      // 分页
      pageNum: 1,
      total: 0,
      params: {
        name: this.$route.query.paramStr || null,
        type: this.type,
        pageNo: 1,
        pageSize: 12,
      },
      // 加载状态
      scrollFlag: false,
      isEnd: false,
      filterFlag: false,
    };
  },
  created() {
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
    this.userTidy()
    this.userList(this.params);
  },
  watch: {
      type: {
        handler(newVla) {
            this.filterFlag = true;
            if (this.filterFlag) {
                this.pageNum = 1;
                this.messageList = [];
            }
            this.params.type = newVla; // 2百家 4百科 5机构
            this.userList(this.params);
        },
      },
      
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd ) {
        if (this.filterFlag) {
          this.userList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.userList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    async userList(data) {
      this.isEnd = false
      this.scrollFlag = true
      const resp = await this.$apis.searchServe.userList(data);
      this.total = +resp.data.total;
      this.messageList.push(...resp.data.list);
      if (this.type === 4) {
        this.messageList = this.messageList.filter(item => item.prd)
      }
      this.scrollFlag = false
      this.isEnd = this.pageNum >= this.total / 12
    },
    // 用户相关参数整理
    userTidy() {
      this.eliminate() // 清除多余属性
      this.$set(this.params,this.$route.query.searchType,this.$route.query.paramStr) // 动态的添加属性和值
    },
    // 参数清除
    eliminate() {
      this.$delete(this.params,'name')
      this.$delete(this.params,'organizerUnit')
      this.$delete(this.params,'dominantAgency')
      this.$delete(this.params,'publishUnit')
      this.$delete(this.params,'cn')
      this.$delete(this.params,'issn')
    }
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
};
</script>

<style lang="scss" scoped>
.side {
  width: 300px;
  margin-right: 11px;
}
.content {
  width: 100%;
  background-color: #fff;
}
</style>
